import React from 'react'
import helpers from 'core/helpers/_files'
import { cn } from 'ethcss'
import styles from './rectangle.jcss'
import { RectangleContentProps, RectangleDefaultProps, RectangleProps } from './rectangle.types'

const Rectangle = (p_: RectangleProps) => {
    const paddingBottom = (p_.height / p_.width) * 100
    let contentProps: RectangleContentProps = {
        className: cn(p_.className, styles.content),
    }

    if (p_.src) {
        const isSvgThumbnail = helpers.isSvgThumbnail(p_.src)

        contentProps = {
            style: {
                backgroundImage: `url(${p_.src})`,
            },
            className: cn(p_.className, {
                [styles.center]: p_.center,
                [styles.contain]: p_.contain,
                [styles.cover]: !p_.center && !p_.contain && !isSvgThumbnail,
                [styles.fullWidth]: isSvgThumbnail,
            }),
        }
    }

    return (
        <div
            onClick={p_.onClick}
            onMouseDown={p_.onMouseDown}
            onMouseUp={p_.onMouseUp}
            className={cn(styles.wrapper, p_.containerClassName)}
            style={p_.containerStyles}
        >
            <div {...contentProps} onScroll={p_.onScroll}>
                {p_.children}
            </div>
            <div style={{ paddingBottom: `${paddingBottom}%` }} />
        </div>
    )
}

const defaultProps: RectangleDefaultProps = {
    width: 1,
    height: 1,
    onClick: () => {},
}

Rectangle.defaultProps = defaultProps

export default Rectangle
